import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/HptScreens.css'; 
import Swal from 'sweetalert2';
import PermisoEscalera from '../components/PermisoEscalera';


// BackEnd de Serveless
const API_URL = process.env.REACT_APP_API_URL;

// ============================================================================
// COMPONENTE: ExpandableCard (Acordeón unificado)
// ============================================================================
const ExpandableCard = ({ title, icon, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="expandable-card">
            <div className="card-header" onClick={() => setIsOpen(!isOpen)}>
                <span>{icon} {title}</span>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            <div className={`card-content ${isOpen ? 'open' : ''}`}>
                {children}
            </div>
        </div>
    );
};

// ============================================================================
// COMPONENTE PRINCIPAL: EditHPTScreen
// ============================================================================
const EditHPTScreen = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    
    // --- ESTADOS DE CATÁLOGOS (Servidor) ---
    const [localizaciones, setLocalizaciones] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [catalogo, setCatalogo] = useState([]);
    const [loading, setLoading] = useState(true); // Spinner de carga inicial
    
    // --- ESTADOS DE LISTAS DINÁMICAS ---
    const [seleccionados, setSeleccionados] = useState([]); // IDs de riesgos/medidas
    const [materiales, setMateriales] = useState([]);       // Repuestos
    const [recursos, setRecursos] = useState([]);           // Energías y trabajos previos
    const [trabajadores, setTrabajadores] = useState([]);   // Empleados subcontrata
    const [imagenesBase64, setImagenesBase64] = useState([]); // Fotos actuales y nuevas

    // --- ESTADOS DEL BUSCADOR DE ACTIVOS ---
    const [busquedaActivo, setBusquedaActivo] = useState('');
    const [mostrarDesplegable, setMostrarDesplegable] = useState(false);
    const [opcionesActivos, setOpcionesActivos] = useState([]);

    // --- Para autocompletar bloques de usuarios ---
    const [busquedaUsuarios, setBusquedaUsuarios] = useState('');
    const [mostrarDesplegableUsuarios, setMostrarDesplegableUsuarios] = useState(false);
    const [opcionesUsuarios, setOpcionesUsuarios] = useState([]);

    // --- Añadido a Riesgos Maquinaria Medida Otros
    const [detallesRiesgos, setDetallesRiesgos] = useState({});

    //Modal Escalera
    const [showEscaleraModal, setShowEscaleraModal] = useState(false); 
    const [datosEscaleraEditados, setDatosEscaleraEditados] = useState(null);


    // --- ESTADOS PARA DOCUMENTOS --- 
    const [archivosSubidos, setArchivosSubidos] = useState([]); // Archivos que ya estan en R2
    const [archivosNuevos, setArchivosNuevos] = useState([]);   // Archivos que se van a añadir a R2

    // --- Catálogos Eléctricos ---
    const [electricosBloqueo, setElectricosBloqueo] = useState([]);
    const [electricosDescargo, setElectricosDescargo] = useState([]);
    // --- Tablas de Maniobra asignadas a la HPT ---
    const [bloqueosElectricos, setBloqueosElectricos] = useState([]);
    const [descargosElectricos, setDescargosElectricos] = useState([]);
    // --- Asociacion Manual de LOTOS OTRA HPT ---
    const [numManualBloqueo, setNumManualBloqueo] = useState('');
    const [numManualDescargo, setNumManualDescargo] = useState('');
    const [ptwVinculadoBloqueo, setPtwVinculadoBloqueo] = useState('');
    const [ptwVinculadoDescargo, setPtwVinculadoDescargo] = useState('');

    // --- ESTADO CENTRAL DEL FORMULARIO ---
    const [formData, setFormData] = useState({
        titulo: '',
        id_st: '',
        ot_referencia: '',
        id_activo: '',
        den_act_descripcion: '',
        descripcion_trabajo: '',
        operarios_previstos: '',
        duracion_prevista_hours: '',
        fecha_prevista: '',
        horario_previsto: '',
        id_localizacion: '',
        interviene_subcontrata: false,
        id_usuario_subcontrata: null,
        preventivos: [],
        tipo_incidencia: 'PREVENTIVO',
        dias_previstos: ''
    });

    // --- CONFIGURACIÓN DE RECURSOS ---
    const CONFIG_RECURSOS = {
        'EQUIPO ESPECIAL': ['Andamiero', 'Calorifugador', 'Soldador', 'ENDs', 'Mecanizado', 'Grup. Electrógeno', 'Compresor', 'Luminarias'],
        'ACCESO': ['Andamio / Andamio taller', 'Plataforma elevadora', 'Anticaídas Retráctiles', 'Línea de vida', 'Banqueta/alfombra', 'Escalera', 'Pescante/tripode'],
        'ENERGÍA TRABAJO': ['Agua', 'N2', 'Argon', 'Aire', 'Electricidad', 'Gasolina/Gasoil'],
        'ENERGÍA EQUIPO': ['HTF', 'Agua', 'Vapor', 'Químicos', 'Nitrógeno', 'Electrica', '75v CC/50v CA'],
        'TRABAJOS PREVIOS': ['Enclavamiento eléctrico', 'Descargo eléctrico', 'Descargo mecánico', 'Doble Verificación', 'Despresurizar', 'Drenar', 'PCI Fuera de Servicio', 'Inertizar (N2)', 'INERTIZAR CON VAPOR', 'VENTEO', 'LAVADO DE LÍNEAS', 'SEÑALES FORZADAS DCS', 'EQUIPOS EN TAGOUT', 'DESCARGO LOCs', 'Levantamiento en pruebas']
    };

    // ============================================================================
    //  IDENTIFICACIÓN DEL USUARIO LOGUEADO (Síncrono)
    // ============================================================================
    const token = localStorage.getItem('userToken');
    let currentUser = {};
    let nombreUsuarioCompleto = 'Usuario Desconocido';

    if (token) {
        try {
            currentUser = JSON.parse(atob(token.split('.')[1]));
            nombreUsuarioCompleto = `${currentUser.nombre || ''} ${currentUser.apellidos || ''}`.trim() || currentUser.user_name || 'Usuario';
        } catch(e) { 
            console.error("Error leyendo token"); 
        }
    }

    // ============================================================================
    // CARGA INICIAL
    // ============================================================================
    useEffect(() => {
        const userRol = currentUser.rol || '';
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const fetchData = async () => {
            try {
                const [resLocs, resUsers, resCatalogo, resHpt, resArchivos, resElecBloqueo, resElecDescargo] = await Promise.all([
                    axios.get(`${API_URL}/api/catalogos/localizaciones`, config),
                    axios.get(`${API_URL}/api/catalogos/usuarios`, config),
                    axios.get(`${API_URL}/api/catalogos/seguridad`, config),
                    axios.get(`${API_URL}/api/hpt/${id}`, config),
                    axios.get(`${API_URL}/api/hpt/${id}/archivos`, config),
                    axios.get(`${API_URL}/api/catalogos/electricosBloqueo`, config),
                    axios.get(`${API_URL}/api/catalogos/electricosDescargo`, config)
                ]);

                const extractData = (res) => res.data.results ? res.data.results : res.data;

                setLocalizaciones(extractData(resLocs));
                setUsuarios(extractData(resUsers));
                setCatalogo(extractData(resCatalogo));
                setElectricosBloqueo(extractData(resElecBloqueo));
                setElectricosDescargo(extractData(resElecDescargo));

                // Inyectamos los datos de la base de datos en los estados
                const hpt = resHpt.data;
                const listaPreventivos = hpt.preventivos_detallados?.map(p => p.nombre_recurso_preventivo) || [];
                setFormData({
                    ...hpt,
                    titulo: hpt.titulo || '',
                    id_st: hpt.id_st || '',
                    tipo_incidencia: hpt.tipo_incidencia || 'PREVENTIVO',
                    preventivos: listaPreventivos
                });
                
                setImagenesBase64(hpt.imagenes || []);
                setBusquedaActivo(hpt.codigo_activo || '');
                setBusquedaUsuarios(listaPreventivos.join(', '));
                setSeleccionados(hpt.riesgos_detallados?.map(r => r.id_item) || []);
                setMateriales(hpt.materiales || []);
                setRecursos(hpt.recursos || []);
                setTrabajadores(hpt.trabajadores || []);

                const detallesRecuperados = {};
                if (hpt.riesgos_detallados) {
                    hpt.riesgos_detallados.forEach(r => {
                        if (r.observacion_riesgo) {
                            detallesRecuperados[r.id_item] = r.observacion_riesgo;
                        }
                    });
                }

                setDetallesRiesgos(detallesRecuperados);

                setArchivosSubidos(resArchivos.data || []);

                setBloqueosElectricos(hpt.bloqueos_electricos || []);
                setDescargosElectricos(hpt.descargos_electricos || []);
                if (hpt.anexo_escalera) {
                    setDatosEscaleraEditados({
                        ...hpt.anexo_escalera,
                        clasificacion: typeof hpt.anexo_escalera.clasificacion === 'string' 
                            ? hpt.anexo_escalera.clasificacion.split(', ').filter(Boolean) 
                            : (Array.isArray(hpt.anexo_escalera.clasificacion) ? hpt.anexo_escalera.clasificacion : []),
                        justificacion: typeof hpt.anexo_escalera.justificacion === 'string' 
                            ? hpt.anexo_escalera.justificacion.split(', ').filter(Boolean) 
                            : (Array.isArray(hpt.anexo_escalera.justificacion) ? hpt.anexo_escalera.justificacion : [])
                    });
                } else {
                    setDatosEscaleraEditados(null);
                }
                
                setLoading(false);
                
            } catch (err) { 
                console.error("Error cargando datos:", err); 
                Swal.fire({
                    title: "Error al recuperar la información",
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            }
        };
        fetchData();
    }, [id]);

    // ============================================================================
    // FUNCIONES: AUTOCOMPLETAR ACTIVOS
    // ============================================================================
    const buscadorTimeout = useRef(null);
    const buscarActivosEnServidor = async (texto) => {
        setBusquedaActivo(texto);

        if (buscadorTimeout.current) {
            clearTimeout(buscadorTimeout.current);
        }
        
        // Al menos tres letras, para realizar peticiones al servidor
        if (texto.length < 3) {
            setOpcionesActivos([]);
            return;
        }

        // Tiempo de espera para el disparador
        buscadorTimeout.current = setTimeout(async () => {
            try {
                const token = localStorage.getItem('userToken');
                const res = await axios.get(`${API_URL}/api/catalogos/activos/buscar?q=${texto}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                // Guardamos los resultados optimizados
                setOpcionesActivos(res.data.results || []);
            } catch (err) {
                console.error("Error buscando activos en el catálogo:", err);
            }
        }, 350);
    };

    const seleccionarActivo = (activo) => {
        setFormData({
            ...formData,
            id_activo: activo.id_activo,
            den_act_descripcion: activo.denominacion
        });
        setBusquedaActivo(activo.codigo_activo);
        setMostrarDesplegable(false);
    };

    // ============================================================================
    // FUNCIONES: BUSCADOR DE USUARIOS (AUTOCOMPLETAR)
    // ============================================================================
    const buscarUsuariosServidor = async (texto) => {
        setBusquedaUsuarios(texto);
        
        // Al menos tres letras, para realizar peticiones al servidor
        if (texto.length < 2) {
            setOpcionesUsuarios([]);
            return;
        }

        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/catalogos/usuarios/buscar?q=${texto}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Guarda los resultados en el estado para mostrarlos en la lista desplegable
            setOpcionesUsuarios(res.data.results || []);
        } catch (err) {
            console.error("Error buscando usuarios:", err);
        }
    };

    const seleccionarListaUsuarios = (opcion) => {
        const seleccion = opcion.valor;
        if (!formData.preventivos.includes(seleccion)) {
            setFormData({
                ...formData,
                preventivos: [...formData.preventivos, seleccion]
            });
        }
        
        setBusquedaUsuarios('');
        setMostrarDesplegableUsuarios(false);
    };

    // ============================================================================
    // FUNCIONES: GESTORES DE ARRAYS DINÁMICOS
    // ============================================================================
    // --- Materiales ---
    const addMaterial = () => setMateriales([...materiales, { descripcion: '', unidades: '', almacen: '' }]);
    const updateMaterial = (idx, field, val) => {
        const newM = [...materiales];
        newM[idx][field] = val;
        setMateriales(newM);
    };

    // --- Recursos y Energías ---
    const handleRecursoToggle = (cat, nombre, checked) => {
        const exists = recursos.find(r => r.categoria === cat && r.nombre_recurso === nombre);
        if (exists) {
            setRecursos(recursos.map(r => (r.categoria === cat && r.nombre_recurso === nombre) ? { ...r, valor_check: checked } : r));
        } else {
            setRecursos([...recursos, { categoria: cat, nombre_recurso: nombre, valor_check: checked, detalle_texto: "" }]);
        }
    };

    const handleRecursoText = (cat, nombre, texto) => {
        setRecursos(recursos.map(r => 
            (r.categoria === cat && r.nombre_recurso === nombre) 
                ? { ...r, detalle_texto: texto } 
                : r
        ));
    };

    // --- Trabajadores Subcontrata ---
    const addTrabajador = () => {
        setTrabajadores([...trabajadores, {
            nombre: '', apellidos: '', empresa: '', carretilla_elevadora: false, carretilla_telescopica: false,
            plataforma_elevadora: false, puente_grua: false, espacios_confinados: false,
            baja_tension: false, alta_tension: false, recurso_preventivo: false,
            camion_pluma: false, grua: false, formacion_altura: false, otros: ''
        }]);
    };

    const updateTrabajador = (idx, field, val) => {
        const newT = [...trabajadores];
        newT[idx][field] = val;
        setTrabajadores(newT);
    };


    const puedeEditarEscalera = () => {
        return true;
    };

    // ============================================================================
    // ACTUALIZACIÓN DE ANEXO ESCALERA
    // ============================================================================
    const handleActualizarEscalera = async (datosNuevosEscalera) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        const toBool = (v) => v === 1 || v === true || v === '1' || v === 'true';

        const anexoFormateado = {
            firmaSolRetirada: datosNuevosEscalera.firmaSolRetirada ?? null,
            firmaAutRetirada: datosNuevosEscalera.firmaAutRetirada ?? null,
            firmaUsuEscalera: datosNuevosEscalera.firmaUsuEscalera ?? null,
            firmaSolDevolucion: datosNuevosEscalera.firmaSolDevolucion ?? null,
            firmaRecDevolucion: datosNuevosEscalera.firmaRecDevolucion ?? null,
            medioAutorizacion: datosNuevosEscalera.medioAutorizacion ?? null,

            fechaSolicitud: datosNuevosEscalera.fechaSolicitud || datosNuevosEscalera.fecha_solicitud || "",
            delegacion: datosNuevosEscalera.delegacion || "",
            ubicacion: datosNuevosEscalera.ubicacion || "",
            responsable: datosNuevosEscalera.responsable || "",
            ordenTrabajo: datosNuevosEscalera.ordenTrabajo || datosNuevosEscalera.orden_trabajo || "",
            trabajoRealizar: datosNuevosEscalera.trabajoRealizar || datosNuevosEscalera.trabajo_realizar || "",
            numeroSerie: datosNuevosEscalera.numeroSerie || datosNuevosEscalera.numero_serie || "",
            
            altura: (datosNuevosEscalera.altura !== null && datosNuevosEscalera.altura !== undefined && datosNuevosEscalera.altura !== "") ? Number(datosNuevosEscalera.altura) : undefined,
            
            checkId: toBool(datosNuevosEscalera.checkId ?? datosNuevosEscalera.check_id),
            checkZona: toBool(datosNuevosEscalera.checkZona ?? datosNuevosEscalera.check_zona),
            checkPeldaños: toBool(datosNuevosEscalera.checkPeldaños ?? datosNuevosEscalera.check_peldaños),
            checkZapatas: toBool(datosNuevosEscalera.checkZapatas ?? datosNuevosEscalera.check_zapatas),
            
            clasificacion: Array.isArray(datosNuevosEscalera.clasificacion) ? datosNuevosEscalera.clasificacion.join(', ') : (datosNuevosEscalera.clasificacion || ''),
            justificacion: Array.isArray(datosNuevosEscalera.justificacion) ? datosNuevosEscalera.justificacion.join(', ') : (datosNuevosEscalera.justificacion || '')
        };

        const payload = {
            anexo_escalera: anexoFormateado,
            interviene_subcontrata: formData.interviene_subcontrata === true
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/escalera`, payload, config);
            Swal.fire('Guardado', 'El Permiso de Escalera se ha actualizado correctamente.', 'success');
            setDatosEscaleraEditados(datosNuevosEscalera); 
            setShowEscaleraModal(false);
        } catch (error) {
            console.error("Error actualizando escalera:", error);
            const detalles = error.response?.data?.detalles;
            if (detalles) {
                Swal.fire('Error de Validación', JSON.stringify(detalles, null, 2), 'error');
            } else {
                Swal.fire('Error', 'No se pudo actualizar el permiso de escalera.', 'error');
            }
        }
    };

    

    // ============================================================================
    // FUNCIONES: GESTIÓN DE DOCUMENTOS (R2)
    // ============================================================================
    const handleDescargarArchivo = async (idArchivo, nombre, tipo) => {
        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/hpt/archivo/${idArchivo}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob'
            });

            // Forzar a descargar en el navegador
            const url = window.URL.createObjectURL(new Blob([res.data], { type: tipo }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombre);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            Swal.fire('Error', 'No se pudo descargar el archivo.', 'error');
        }
    };

    const handleEliminarArchivoServidor = async (idArchivo, nombre) => {
        const confirm = await Swal.fire({
            title: '¿Eliminar archivo?',
            text: `Se borrará "${nombre}" permanentemente de la nube.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            confirmButtonText: 'Sí, borrar'
        });

        if (confirm.isConfirmed) {
            try {
                const token = localStorage.getItem('userToken');
                await axios.delete(`${API_URL}/api/hpt/archivo/${idArchivo}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setArchivosSubidos(prev => prev.filter(a => a.id_archivo !== idArchivo));
                Swal.fire('Borrado', 'El archivo ha sido eliminado.', 'success');
            } catch (error) {
                Swal.fire('Error', 'No se pudo eliminar el archivo.', 'error');
            }
        }
    };

    // ============================================================================
    // LÓGICA DE CONTROL: MATRICES ELÉCTRICAS (BLOQUEOS / DESCARGOS)
    // ============================================================================
    // --- Bloqueos ---
    const addBloqueoElectrico = () => setBloqueosElectricos([...bloqueosElectricos, { num_consignacion: Math.floor(Math.random() * 1000000), id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '', textoBusqueda: '', mostrarDesplegable: false }]);
    const removeBloqueoElectrico = (idx) => setBloqueosElectricos(bloqueosElectricos.filter((_, i) => i !== idx));
    const handleFilaBloqueoChange = (idx, texto) => {
        const filas = [...bloqueosElectricos]; filas[idx].textoBusqueda = texto; filas[idx].mostrarDesplegable = texto.length >= 2;
        if(texto === '') { filas[idx].activo = ''; filas[idx].centro_cargas = ''; filas[idx].ubicacion = ''; filas[idx].tension = ''; filas[idx].descripcion = ''; }
        setBloqueosElectricos(filas);
    };
    const toggleBloqueoDesplegable = (idx, vis) => { const filas = [...bloqueosElectricos]; filas[idx].mostrarDesplegable = vis && filas[idx].textoBusqueda.length >= 2; setBloqueosElectricos(filas); };
    const seleccionarElementoBloqueoElectrico = (idx, elem) => {
        const filas = [...bloqueosElectricos];
        const numActual = filas[idx].num_consignacion || Math.floor(Math.random() * 1000000);
        filas[idx] = { num_consignacion: numActual, id_item: elem.id_item, activo: elem.activo, centro_cargas: elem.centro_cargas || 'S/C', ubicacion: elem.ubicacion || 'S/U', tension: elem.tension, descripcion: elem.descripcion || '', textoBusqueda: elem.activo, mostrarDesplegable: false };
        setBloqueosElectricos(filas);
    };

    const addBloqueoManual = () => {
        if (!numManualBloqueo) return;
        setBloqueosElectricos([...bloqueosElectricos, {
            num_consignacion: parseInt(numManualBloqueo),
            id_item: '', activo: 'MANUAL', centro_cargas: '-', ubicacion: '-', tension: 0,
            descripcion: ptwVinculadoBloqueo ? `LOTO vinculado al PTW: ${ptwVinculadoBloqueo}` : 'Consignación manual',
            textoBusqueda: ptwVinculadoBloqueo ? `[MANUAL] Nº ${numManualBloqueo} (PTW: ${ptwVinculadoBloqueo})` : `[MANUAL] Nº ${numManualBloqueo}`,
            mostrarDesplegable: false,
            ptw_vinculado: ptwVinculadoBloqueo || null 
        }]);
        setNumManualBloqueo('');
        setPtwVinculadoBloqueo('');
    };

    // --- Descargos ---
    const addDescargoElectrico = () => setDescargosElectricos([...descargosElectricos, { num_consignacion: Math.floor(Math.random() * 1000000), id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '', textoBusqueda: '', mostrarDesplegable: false }]);
    const removeDescargoElectrico = (idx) => setDescargosElectricos(descargosElectricos.filter((_, i) => i !== idx));
    const handleFilaDescargoChange = (idx, texto) => {
        const filas = [...descargosElectricos]; filas[idx].textoBusqueda = texto; filas[idx].mostrarDesplegable = texto.length >= 2;
        if(texto === '') { filas[idx].activo = ''; filas[idx].centro_cargas = ''; filas[idx].ubicacion = ''; filas[idx].tension = ''; filas[idx].descripcion = ''; }
        setDescargosElectricos(filas);
    };
    const toggleDescargoDesplegable = (idx, vis) => { const filas = [...descargosElectricos]; filas[idx].mostrarDesplegable = vis && filas[idx].textoBusqueda.length >= 2; setDescargosElectricos(filas); };
    const seleccionarElementoDescargoElectrico = (idx, elem) => {
        const filas = [...descargosElectricos];
        const numActual = filas[idx].num_consignacion || Math.floor(Math.random() * 1000000);
        filas[idx] = { num_consignacion: numActual, id_item: elem.id_item, activo: elem.activo, centro_cargas: elem.centro_cargas || 'S/C', ubicacion: elem.ubicacion || 'S/U', tension: elem.tension, descripcion: elem.descripcion || '', textoBusqueda: elem.activo, mostrarDesplegable: false };
        setDescargosElectricos(filas);
    };

    const addDescargoManual = () => {
        if (!numManualDescargo) return;
        setDescargosElectricos([...descargosElectricos, {
            num_consignacion: parseInt(numManualDescargo),
            id_item: '', activo: 'MANUAL', centro_cargas: '-', ubicacion: '-', tension: 0,
            descripcion: ptwVinculadoDescargo ? `LOTO vinculado al PTW: ${ptwVinculadoDescargo}` : 'Consignación manual',
            textoBusqueda: ptwVinculadoDescargo ? `[MANUAL] Nº ${numManualDescargo} (PTW: ${ptwVinculadoDescargo})` : `[MANUAL] Nº ${numManualDescargo}`,
            mostrarDesplegable: false,
            ptw_vinculado: ptwVinculadoDescargo || null 
        }]);
        setNumManualDescargo('');
        setPtwVinculadoDescargo('');
    };

    // ============================================================================
    // GUARDADO (Actualizar Base de Datos)
    // ============================================================================
    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('userToken');
        
        try {
            // 1. Limpiamos MATERIALES: Filtramos filas vacías y forzamos el formato correcto
            const materialesLimpios = materiales
                .filter(m => (m.descripcion || '').trim() !== '' || (m.almacen || '').trim() !== '')
                .map(m => ({
                    descripcion: m.descripcion || '',
                    unidades: m.unidades ? String(m.unidades) : '',
                    almacen: m.almacen || ''
                }));

            // 2. Limpiamos TRABAJADORES: Quitar filas sin nombre y forzar booleanos reales
            const trabajadoresLimpios = trabajadores
                .filter(t => (t.nombre || '').trim() !== '' || (t.apellidos || '').trim() !== '')
                .map(t => ({
                    nombre: t.nombre || '',
                    apellidos: t.apellidos || '',
                    empresa: t.empresa || '',
                    carretilla_elevadora: !!t.carretilla_elevadora,
                    carretilla_telescopica: !!t.carretilla_telescopica,
                    plataforma_elevadora: !!t.plataforma_elevadora,
                    puente_grua: !!t.puente_grua,
                    espacios_confinados: !!t.espacios_confinados,
                    baja_tension: !!t.baja_tension,
                    alta_tension: !!t.alta_tension,
                    recurso_preventivo: !!t.recurso_preventivo,
                    camion_pluma: !!t.camion_pluma,
                    grua: !!t.grua,
                    formacion_altura: !!t.formacion_altura,
                    otros: t.otros || ''
                }));

            // 3. Limpiamos RECURSOS: Forzamos booleanos reales para los checks
            const recursosLimpios = recursos.map(r => ({
                categoria: r.categoria,
                nombre_recurso: r.nombre_recurso,
                valor_check: !!r.valor_check,
                detalle_texto: r.detalle_texto || ""
            }));

            // Comprobamos de manera reactiva si el check de escalera sigue activo
            const tieneEscaleraActiva = recursosLimpios.some(r => r.categoria === 'ACCESO' && r.nombre_recurso === 'Escalera' && r.valor_check);
            const toBool = (v) => v === 1 || v === true || v === '1' || v === 'true';
            
            let anexoEscaleraFinal = undefined; 

            if (tieneEscaleraActiva && datosEscaleraEditados) {
                anexoEscaleraFinal = {
                    firmaSolRetirada: datosEscaleraEditados.firmaSolRetirada ?? null,
                    firmaAutRetirada: datosEscaleraEditados.firmaAutRetirada ?? null,
                    firmaUsuEscalera: datosEscaleraEditados.firmaUsuEscalera ?? null,
                    firmaSolDevolucion: datosEscaleraEditados.firmaSolDevolucion ?? null,
                    firmaRecDevolucion: datosEscaleraEditados.firmaRecDevolucion ?? null,
                    medioAutorizacion: datosEscaleraEditados.medioAutorizacion ?? null,
                    fechaSolicitud: datosEscaleraEditados.fechaSolicitud || datosEscaleraEditados.fecha_solicitud || "",
                    delegacion: datosEscaleraEditados.delegacion || "",
                    ubicacion: datosEscaleraEditados.ubicacion || "",
                    responsable: datosEscaleraEditados.responsable || "",
                    ordenTrabajo: datosEscaleraEditados.ordenTrabajo || datosEscaleraEditados.orden_trabajo || "",
                    trabajoRealizar: datosEscaleraEditados.trabajoRealizar || datosEscaleraEditados.trabajo_realizar || "",
                    numeroSerie: datosEscaleraEditados.numeroSerie || datosEscaleraEditados.numero_serie || "",
                    altura: (datosEscaleraEditados.altura !== null && datosEscaleraEditados.altura !== undefined && datosEscaleraEditados.altura !== "") ? Number(datosEscaleraEditados.altura) : undefined,
                    checkId: toBool(datosEscaleraEditados.checkId ?? datosEscaleraEditados.check_id),
                    checkZona: toBool(datosEscaleraEditados.checkZona ?? datosEscaleraEditados.check_zona),
                    checkPeldaños: toBool(datosEscaleraEditados.checkPeldaños ?? datosEscaleraEditados.check_peldaños),
                    checkZapatas: toBool(datosEscaleraEditados.checkZapatas ?? datosEscaleraEditados.check_zapatas),
                    clasificacion: Array.isArray(datosEscaleraEditados.clasificacion) ? datosEscaleraEditados.clasificacion.join(', ') : (datosEscaleraEditados.clasificacion || ''),
                    justificacion: Array.isArray(datosEscaleraEditados.justificacion) ? datosEscaleraEditados.justificacion.join(', ') : (datosEscaleraEditados.justificacion || '')
                };
            }

            // 4. Armamos el Payload
            const payload = {
                ...formData,
                id_activo: formData.id_activo ? parseInt(formData.id_activo) : null,
                id_localizacion: formData.id_localizacion ? parseInt(formData.id_localizacion) : null,
                operarios_previstos: formData.operarios_previstos ? parseInt(formData.operarios_previstos) : null,
                duracion_prevista_hours: formData.duracion_prevista_hours ? parseInt(formData.duracion_prevista_hours) : null,
                id_usuario_subcontrata: formData.interviene_subcontrata && formData.id_usuario_subcontrata ? parseInt(formData.id_usuario_subcontrata) : null,
                riesgos_seleccionados: seleccionados.map(id => ({
                    id_item_seguridad: parseInt(id),
                    observacion_riesgo: detallesRiesgos[id] || ""
                })),
                dias_previstos: formData.dias_previstos ? parseInt(formData.dias_previstos) : 1,

                materiales: materialesLimpios, 
                recursos: recursosLimpios, 
                trabajadores: trabajadoresLimpios, 
                imagenes: imagenesBase64,

                bloqueos_electricos: bloqueosElectricos.filter(b => b.activo !== ''),
                descargos_electricos: descargosElectricos.filter(d => d.activo !== ''),
                anexo_escalera: anexoEscaleraFinal

            };

            console.log("Payload limpio a enviar:", payload);

            // 5. Enviamos la petición PUT (Actualizar)
            await axios.put(`${API_URL}/api/hpt/${id}`, payload, { 
                headers: { Authorization: `Bearer ${token}` } 
            });

            // 6. Subimos nuevos documentos adjuntos  (Si los hay)
            if (archivosNuevos.length > 0) {
                for (const file of archivosNuevos) {
                    const formDataFile = new FormData();
                    formDataFile.append('file', file);
                    await axios.post(`${API_URL}/api/hpt/${id}/subir-archivo`, formDataFile, {
                        headers: { 
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data' 
                        }
                    });
                }
            }
            
            Swal.fire({
                title: "HPT actualizada correctamente.",
                icon: "success",
                confirmButtonColor: '#003366'
            })
            navigate(`/detalles-hpt/${id}`);

        } catch (err) { 
            console.error("❌ Error al actualizar:", err.response?.data || err);
            
            const detalles = err.response?.data?.detalles || err.response?.data?.detail;
            if (detalles) {
                Swal.fire({
                    title: "Error de validación del servidor.",
                    text: `Error de validación del servidor:\n${JSON.stringify(detalles, null, 2)}`,
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            } else {
                Swal.fire({
                    title: "Error al actualizar la planificación.",
                    text: err.response?.data || err,
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            }
        }
    };

    if (loading) return <div style={{padding: '50px'}}>Recuperando planificación...</div>;

    const categoriasSeguridad = [...new Set(catalogo.map(item => item.categoria))];

    // ============================================================================
    // GESTIÓN DE IMÁGENES
    // ============================================================================
    const comprimirImagen = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const MAX_WIDTH = 800;
                    const scaleSize = MAX_WIDTH / img.width;
                    canvas.width = MAX_WIDTH;
                    canvas.height = img.height * scaleSize;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    resolve(canvas.toDataURL('image/jpeg', 0.6));
                };
            };
        });
    };

    const eliminarImagen = (indexToRemove) => {
        setImagenesBase64(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    // ============================================================================
    // RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="container">
            <form onSubmit={handleSubmit}>
                
                {/* --- 1. CABECERA--- */}
                <div className="top-header">
                    <div className="d-flex align-center">
                        <span className="ptw-label">EDITANDO:</span>
                        <div className="ptw-badge">
                            <span style={{ fontSize: '20px' }}>✏️</span> 
                            OT: {formData.ot_referencia || 'SIN ASIGNAR'}
                        </div>
                    </div>
                    <div className="header-actions">
                        <button type="submit" className="btn-save" style={{ backgroundColor: '#1a237e' }}>💾 Guardar Cambios</button>
                        <button type="button" onClick={() => navigate(-1)} className="btn-discard">Descartar</button>
                    </div>
                </div>

                {/* --- 2. TARJETA PRINCIPAL --- */}
                <div className="main-card">
                    <div className="card-header-internal">Información de Planificación</div>

                    <div className="row">
                        <div className="info-box mb-20">
                            <span className="info-label">Título</span>
                            <input 
                                type="text" 
                                className="main-input input-titulo-edit" 
                                value={formData.titulo || ''} 
                                onChange={e => setFormData({...formData, titulo: e.target.value})}
                            />
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">NÚMERO DE OT:</span>
                            <input type="text" value={formData.ot_referencia || ''} required className="main-input" onChange={e => setFormData({...formData, ot_referencia: e.target.value})} />
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">ID ST:</span>
                            <input type="text" value={formData.id_st || ''} className="main-input" onChange={e => setFormData({...formData, id_st: e.target.value})} />
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">ZONA DE TRABAJO:</span>
                            <select value={formData.id_localizacion || ''} required className="main-select" onChange={e => setFormData({...formData, id_localizacion: e.target.value})}>
                                <option value="">-- Seleccione Zona --</option>
                                {localizaciones.map(loc => <option key={loc.id_localizacion} value={loc.id_localizacion}>{loc.nombre_zona}</option>)}
                            </select>
                        </div>
                        <div className="info-box flex-1">
                            <label className="info-label">Tipo de Incidencia *</label>
                            <select 
                                className="main-select"
                                value={formData.tipo_incidencia || 'PREVENTIVO'} 
                                onChange={e => setFormData({...formData, tipo_incidencia: e.target.value})}
                                required
                            >
                                <option value="PREVENTIVO">PREVENTIVO</option>
                                <option value="CORRECTIVO">CORRECTIVO</option>
                                <option value="MODIFICACION">MODIFICACIÓN</option>
                            </select>
                        </div>
                    </div>

                    {/* SECCIÓN ACTIVO (Buscador Autocompletar) */}
                    <div className="asset-section-hpt">
                        <div className="row">
                            <div className="info-box flex-1 relative">
                                <span className="info-label">CÓDIGO ACTIVO (Buscador):</span>
                                
                                <input 
                                    type="text" 
                                    className="main-input" 
                                    placeholder="Escriba código o nombre..."
                                    value={busquedaActivo || ''}
                                    onChange={(e) => {
                                        const valor = e.target.value;
                                        buscarActivosEnServidor(valor);
                                        setMostrarDesplegable(valor.length >= 3);
                                        if (formData.id_activo) {
                                            setFormData({...formData, id_activo: '', den_act_descripcion: ''});
                                        }
                                    }}
                                    onFocus={() => setMostrarDesplegable(true)}
                                    onBlur={() => setTimeout(() => setMostrarDesplegable(false), 200)}
                                />

                                {mostrarDesplegable && busquedaActivo.length >= 2 && (
                                    <ul className="autocomplete-list">
                                        {opcionesActivos.length > 0 ? (
                                            opcionesActivos.map(a => (
                                                <li 
                                                    key={a.id_activo} 
                                                    className="autocomplete-item"
                                                    onMouseDown={() => seleccionarActivo(a)} 
                                                >
                                                    <strong>{a.codigo_activo}</strong> <br/>
                                                    <span className="text-small text-muted">{a.denominacion}</span>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="autocomplete-item">No se encontraron activos...</li>
                                        )}
                                    </ul>
                                )}
                            </div>
                            
                            <div className="info-box flex-2 asset-display-box">
                                <span className="info-label">DENOMINACIÓN DEL EQUIPO:</span>
                                <div className="asset-name-text">
                                    {formData.den_act_snapshot || formData.den_act_descripcion || 'Seleccione un activo en el buscador...'}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="info-grid">
                        <div className="info-box">
                            <span className="info-label">👥 OPERARIOS:</span>
                            <input type="number" value={formData.operarios_previstos || ''} className="main-input" onChange={e => setFormData({...formData, operarios_previstos: e.target.value})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">📅 FECHA:</span>
                            <input type="date" value={formData.fecha_prevista || ''} className="main-input" onChange={e => setFormData({...formData, fecha_prevista: e.target.value})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">🕒 HORARIO:</span>
                            <input type="text" value={formData.horario_previsto || ''} className="main-input" onChange={e => setFormData({...formData, horario_previsto: e.target.value})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">⏳ DURACIÓN (H):</span>
                            <input type="number" value={formData.duracion_prevista_hours || ''} className="main-input" onChange={e => setFormData({...formData, duracion_prevista_hours: e.target.value})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">📅 DURACIÓN DÍAS:</span>
                            <input type="text" placeholder="Ej: 1" required className="main-input" value={formData.dias_previstos} onChange={e => setFormData({...formData, dias_previstos: e.target.value})} />
                        </div>
                    </div>

                    <div className="description-container">
                        <span className="info-label">DESCRIPCIÓN DE LAS TAREAS:</span>
                        <textarea rows="3" value={formData.descripcion_trabajo || ''} required className="main-textarea" onChange={e => setFormData({...formData, descripcion_trabajo: e.target.value})} />
                    </div>

                    {/* Recuso Preventivo */}
                    <div className="asset-section-hpt">
                        <div className="row">
                            <div className="info-box flex-1 relative"> 
                                <span className="info-label">🛡️ ASIGNAR RECURSO PREVENTIVO (Usuario o Grupo):</span>
                                
                                <input 
                                    type="text" 
                                    className="main-input" 
                                    placeholder="Escriba el nombre, apellidos, rol o grupo..."
                                    value={busquedaUsuarios}
                                    onChange={(e) => {
                                        buscarUsuariosServidor(e.target.value);
                                        setMostrarDesplegableUsuarios(true);
                                    }}
                                    onFocus={() => setMostrarDesplegableUsuarios(true)}
                                    onBlur={() => setTimeout(() => setMostrarDesplegableUsuarios(false), 200)}
                                />

                                {/* Lista flotante de resultados del buscador */}
                                {mostrarDesplegableUsuarios && busquedaUsuarios.length >= 2 && (
                                    <ul className="autocomplete-list">
                                        {opcionesUsuarios.length > 0 ? (
                                            opcionesUsuarios.map((op, index) => (
                                                <li 
                                                    key={`${op.valor}-${index}`}
                                                    className="autocomplete-item"
                                                    onMouseDown={() => seleccionarListaUsuarios(op)}
                                                >
                                                    <strong>{op.tipo === 'GRUPO' ? '👥 Grupo:' : '👤 Usuario:'} {op.etiqueta}</strong>
                                                    <br/>
                                                    <span className="text-small text-muted" style={{ wordBreak: 'break-all' }}>
                                                        {op.descripcion}
                                                    </span>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="autocomplete-item">No se encontraron resultados...</li>
                                        )}
                                    </ul>
                                )}

                                {/* Mostrar los que ya hemos seleccionado como "chips" */}
                                <div className="selected-tags mt-10">
                                    {formData.preventivos.map((prev, index) => (
                                        <span key={index} className="skill-tag skill-preventive" style={{display: 'inline-block', margin: '5px'}}>
                                            {prev} 
                                            <button 
                                                type="button" 
                                                onClick={() => setFormData({...formData, preventivos: formData.preventivos.filter((_, i) => i !== index)})}
                                                style={{marginLeft: '8px', background: 'none', border: 'none', cursor: 'pointer', color: '#d32f2f', fontWeight: 'bold'}}
                                            >
                                                ✖
                                            </button>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* --- SECCIÓN DE FOTOGRAFÍAS CON BORRADO --- */}
                <div className="mt-20 mb-20">
                    <h3 className="section-title">📸 Fotografías de la HPT</h3>
                    
                    <input 
                        type="file" 
                        accept="image/*" 
                        multiple 
                        onChange={async (e) => {
                            const archivos = Array.from(e.target.files);
                            const base64Array = await Promise.all(archivos.map(file => comprimirImagen(file)));
                            setImagenesBase64(prev => [...prev, ...base64Array]);
                        }} 
                        style={{ marginBottom: '15px' }}
                    />

                    <div className="photo-preview-container">
                        {imagenesBase64.map((imgBase64, index) => (
                            <div key={index} className="relative">
                                <img 
                                    src={imgBase64} 
                                    alt="preview" 
                                    className="img-preview-edit"
                                />
                                <button 
                                    type="button"
                                    onClick={() => eliminarImagen(index)}
                                    className="btn-delete-img"
                                >
                                    X
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                {/* SECCIÓN DE DOCUMENTOS ADJUNTOS (EDICIÓN) */}
                <div className="document-section">
                    <h3 className="section-title">
                        📎 Documentos Adjuntos y Descargos
                    </h3>

                    {archivosSubidos.length > 0 && (
                        <div className="document-list mb-20">
                            <strong className="text-subtitle">Archivos guardados en el servidor:</strong>
                            {archivosSubidos.map(archivo => (
                                <div key={archivo.id_archivo} className="document-item">
                                    <div className="document-info">
                                        <span className="document-icon">💾</span>
                                        <span>
                                            {archivo.nombre_archivo} <br/>
                                            <small className="text-muted-small">Subido el: {new Date(archivo.fecha_subida).toLocaleDateString()}</small>
                                        </span>
                                    </div>
                                    <div className="document-actions">
                                        <button type="button" onClick={() => handleDescargarArchivo(archivo.id_archivo, archivo.nombre_archivo, archivo.tipo_archivo)} className="btn-download-file">
                                            ⬇️ Descargar
                                        </button>
                                        <button type="button" onClick={() => handleEliminarArchivoServidor(archivo.id_archivo, archivo.nombre_archivo)} className="btn-delete-file">
                                            🗑️ Borrar
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Input para añadir NUEVOS archivos */}
                    <div className={`document-upload-zone ${archivosSubidos.length > 0 ? 'with-border' : ''}`}>
                        <strong className="text-subtitle">Añadir nuevos documentos:</strong>
                        <input
                            type="file"
                            accept=".pdf,.xls,.xlsx,.doc,.docx"
                            multiple
                            onChange={(e) => {
                                const files = Array.from(e.target.files);
                                setArchivosNuevos(prev => [...prev, ...files]);
                            }}
                        />
                    </div>

                    {/* Listado temporal de archivos listos para subir */}
                    {archivosNuevos.length > 0 && (
                        <div className="document-list">
                            {archivosNuevos.map((file, index) => (
                                <div key={index} className="document-item document-item-pending">
                                    <div className="document-info">
                                        <span className="document-icon">⏳</span>
                                        <span>{file.name} <em className="text-pending-status">(Pendiente de guardar)</em></span>
                                    </div>
                                    <button type="button" onClick={() => setArchivosNuevos(prev => prev.filter((_, i) => i !== index))} className="btn-delete-file">
                                        X Quitar
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* --- 3. ACORDEONES --- */}

                {/* MATERIALES */}
                <ExpandableCard title="Repuestos y Materiales" icon="🔧">
                    <table className="table">
                        <thead>
                            <tr className="table-header-row">
                                <th className="th">Descripción</th>
                                <th className="th">UD</th>
                                <th className="th">Almacén</th>
                                <th className="th"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {materiales.map((m, idx) => (
                                <tr key={idx} className="table-item-row">
                                    <td className="td"><input className="borderless-input" value={m.descripcion || ''} onChange={e => updateMaterial(idx, 'descripcion', e.target.value)} /></td>
                                    <td className="td"><input className="borderless-input" value={m.unidades || ''} onChange={e => updateMaterial(idx, 'unidades', e.target.value)} /></td>
                                    <td className="td"><input className="borderless-input" value={m.almacen || ''} onChange={e => updateMaterial(idx, 'almacen', e.target.value)} /></td>
                                    <td className="td text-center" onClick={() => setMateriales(materiales.filter((_,i) => i !== idx))}>❌</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button type="button" onClick={addMaterial} className="add-btn">+ Añadir Material</button>
                </ExpandableCard>

                {/* RECURSOS Y ENERGÍAS */}
                <ExpandableCard title="Recursos, Energías y Trabajos Previos" icon="⚡">
                    {Object.entries(CONFIG_RECURSOS).map(([categoria, items]) => (
                        <div key={categoria} className="mb-20">
                            <div className="res-cat-title">{categoria}</div>
                            <div className="grid-checks">
                                {items.map(item => {
                                    const recursoEncontrado = recursos.find(r => r.categoria === categoria && r.nombre_recurso === item);
                                    const isChecked = recursoEncontrado ? recursoEncontrado.valor_check : false;
                                    const textoDetalle = recursoEncontrado ? recursoEncontrado.detalle_texto : '';
                                    
                                    return (
                                        <div key={item} style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                            <label className={`hab-item ${isChecked ? 'checked' : ''}`}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={isChecked}
                                                    onChange={(e) => handleRecursoToggle(categoria, item, e.target.checked)} 
                                                />
                                                {item}
                                            </label>

                                            {/* Si es 'Químicos' y está marcado, mostramos la caja de texto */}
                                            {item === 'Químicos' && isChecked && (
                                                <input 
                                                    type="text" 
                                                    className="main-input res-text-input" 
                                                    placeholder="Especifique qué químico..." 
                                                    value={textoDetalle}
                                                    onChange={(e) => handleRecursoText(categoria, item, e.target.value)}
                                                    required
                                                />
                                            )}

                                            {/* Si es 'Escalera' y está marcado, mostramos el botón flotante */}
                                            {item === 'Escalera' && isChecked && (
                                                <div style={{ marginTop: '5px', marginLeft: '25px' }}>
                                                    <button 
                                                        type="button" 
                                                        className="btn-save" 
                                                        style={{ 
                                                            backgroundColor: datosEscaleraEditados ? '#2e7d32' : '#f57c00',
                                                            padding: '6px 12px', fontSize: '12px' 
                                                        }}
                                                        onClick={() => setShowEscaleraModal(true)}
                                                    >
                                                        {datosEscaleraEditados ? '🪜 Anexo Escalera (Completado)' : '🪜 Rellenar Anexo Escalera'}
                                                    </button>
                                                </div>
                                            )}

                                            
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                    {/* EDICIÓN DE BLOQUEOS ELÉCTRICOS */}
                    {recursos.some(r => r.categoria === 'TRABAJOS PREVIOS' && r.nombre_recurso === 'Enclavamiento eléctrico' && r.valor_check) && (
                        <div className="loto-wrapper" style={{ marginTop: '20px' }}>
                            <div className="loto-title-panel">🔒 Matriz de Bloqueos (LOTO)</div>
                            <table className="table">
                                <thead>
                                    <tr className="table-header">
                                        <th className="th" style={{ width: '30%' }}>Tag Activo</th>
                                        <th className="th" style={{ width: '20%' }}>Centro Cargas</th>
                                        <th className="th" style={{ width: '30%' }}>Panel/Celda</th>
                                        <th className="th" style={{ width: '10%' }}>Tensión</th>
                                        <th className="th" style={{ width: '10%', textAlign: 'center' }}>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bloqueosElectricos.map((bloqueo, idx) => (
                                        <tr key={idx}>
                                            <td className="td relative">
                                                <input type="text" className="main-input w-100 loto-yellow-input" value={bloqueo.textoBusqueda} onChange={(e) => handleFilaBloqueoChange(idx, e.target.value)} onFocus={() => toggleBloqueoDesplegable(idx, true)} onBlur={() => setTimeout(() => toggleBloqueoDesplegable(idx, false), 200)} />
                                                {bloqueo.mostrarDesplegable && (
                                                    <ul className="autocomplete-list loto-dropdown">
                                                        {electricosBloqueo.filter(e => e.activo.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase())).map(elem => (
                                                            <li key={elem.id_item} className="autocomplete-item loto-dropdown-item" onMouseDown={() => seleccionarElementoBloqueoElectrico(idx, elem)}>
                                                                <strong>{elem.activo}</strong> — {elem.centro_cargas}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </td>
                                            <td className="td loto-readonly">{bloqueo.centro_cargas}</td>
                                            <td className="td loto-readonly">{bloqueo.ubicacion}</td>
                                            <td className="td loto-readonly text-center">{bloqueo.tension} V</td>
                                            <td className="td text-center"><button type="button" className="del-btn" onClick={() => removeBloqueoElectrico(idx)}>Quitar</button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                                <button type="button" className="add-btn" style={{ marginTop: 0 }} onClick={addBloqueoElectrico}>
                                    + Añadir Bloqueo (Buscador)
                                </button>
                                <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                    <input type="number" className="main-input" placeholder="Nº Bloqueo" value={numManualBloqueo} onChange={(e) => setNumManualBloqueo(e.target.value)} style={{ width: '100px' }} />
                                    <input type="text" className="main-input" placeholder="PTW (Opcional)" value={ptwVinculadoBloqueo} onChange={(e) => setPtwVinculadoBloqueo(e.target.value)} style={{ width: '130px' }} />
                                    <button type="button" className="btn-save" style={{ padding: '6px 12px' }} onClick={addBloqueoManual}>Vincular</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* EDICIÓN DE DESCARGOS ELÉCTRICOS */}
                    {recursos.some(r => r.categoria === 'TRABAJOS PREVIOS' && r.nombre_recurso === 'Descargo eléctrico' && r.valor_check) && (
                        <div className="loto-wrapper" style={{ marginTop: '20px', borderColors: '#2e7d32' }}>
                            <div className="loto-title-panel" style={{ color: '#2e7d32' }}>⚡ Matriz de Descargos (P.A.T)</div>
                            <table className="table">
                                <thead>
                                    <tr className="table-header">
                                        <th className="th" style={{ width: '30%' }}>Tag Activo</th>
                                        <th className="th" style={{ width: '20%' }}>Centro Cargas</th>
                                        <th className="th" style={{ width: '30%' }}>Panel/Celda</th>
                                        <th className="th" style={{ width: '10%' }}>Tensión</th>
                                        <th className="th" style={{ width: '10%', textAlign: 'center' }}>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {descargosElectricos.map((descargo, idx) => (
                                        <tr key={idx}>
                                            <td className="td relative">
                                                <input type="text" className="main-input w-100 loto-yellow-input" value={descargo.textoBusqueda} onChange={(e) => handleFilaDescargoChange(idx, e.target.value)} onFocus={() => toggleDescargoDesplegable(idx, true)} onBlur={() => setTimeout(() => toggleDescargoDesplegable(idx, false), 200)} />
                                                {descargo.mostrarDesplegable && (
                                                    <ul className="autocomplete-list loto-dropdown">
                                                        {electricosDescargo.filter(e => e.activo.toLowerCase().includes(descargo.textoBusqueda.toLowerCase())).map(elem => (
                                                            <li key={elem.id_item} className="autocomplete-item loto-dropdown-item" onMouseDown={() => seleccionarElementoDescargoElectrico(idx, elem)}>
                                                                <strong>{elem.activo}</strong> — {elem.centro_cargas}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </td>
                                            <td className="td loto-readonly">{descargo.centro_cargas}</td>
                                            <td className="td loto-readonly">{descargo.ubicacion}</td>
                                            <td className="td loto-readonly text-center">{descargo.tension} V</td>
                                            <td className="td text-center"><button type="button" className="del-btn" onClick={() => removeDescargoElectrico(idx)}>Quitar</button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                                <button type="button" className="add-btn" style={{ backgroundColor: '#2e7d32', marginTop: 0 }} onClick={addDescargoElectrico}>
                                    + Añadir Descargo (Buscador)
                                </button>
                                <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                    <input type="number" className="main-input" placeholder="Nº Descargo" value={numManualDescargo} onChange={(e) => setNumManualDescargo(e.target.value)} style={{ width: '100px' }} />
                                    <input type="text" className="main-input" placeholder="PTW (Opcional)" value={ptwVinculadoDescargo} onChange={(e) => setPtwVinculadoDescargo(e.target.value)} style={{ width: '130px' }} />
                                    <button type="button" className="btn-save" style={{ padding: '6px 12px' }} onClick={addDescargoManual}>Vincular</button>
                                </div>
                            </div>
                        </div>
                    )}
                </ExpandableCard>

                {/* MATRIZ DE RIESGOS */}
                <ExpandableCard title="Matriz de Riesgos y Medidas" icon="🚨">
                    {categoriasSeguridad.map(cat => (
                        <div key={cat} className="mb-20">
                            <div className="res-cat-title">{cat}</div>
                            <div className="grid-checks">
                                {catalogo.filter(i => i.categoria === cat).map(item => {
                                    const isSelected = seleccionados.includes(item.id_item);
                                    
                                    // Asignamos la clase correcta dependiendo de si es rojo (Riesgo) o verde (Medida Correctiva)
                                    let badgeClass = 'risk-badge';
                                    if (isSelected) {
                                        badgeClass += item.es_riesgo ? ' checked-risk' : ' checked-measure';
                                    }
                                    
                                    const esComodinMaquinaria = item.codigo === '10007';

                                    return (
                                        <div key={item.id_item}>
                                            <label className={badgeClass}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={isSelected} 
                                                    onChange={() => {
                                                        if (isSelected) {
                                                            setSeleccionados(seleccionados.filter(i => i !== item.id_item));
                                                            const nuevosDetalles = { ...detallesRiesgos };
                                                            delete nuevosDetalles[item.id_item];
                                                            setDetallesRiesgos(nuevosDetalles);
                                                        } else {
                                                            setSeleccionados([...seleccionados, item.id_item]);
                                                        }
                                                    }} 
                                                />
                                                <span className={`text-small ${item.es_riesgo ? 'text-risk' : 'text-measure'}`}>
                                                    <strong>{item.codigo}</strong> - {item.descripcion}
                                                </span>
                                            </label>
                                            {isSelected && esComodinMaquinaria && (
                                                <input 
                                                    type="text" 
                                                    className="main-input res-text-input" 
                                                    placeholder="Especifique máquina: ej. Tractor" 
                                                    value={detallesRiesgos[item.id_item] || ''}
                                                    onChange={(e) => setDetallesRiesgos({
                                                        ...detallesRiesgos,
                                                        [item.id_item]: e.target.value
                                                    })}
                                                    required 
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </ExpandableCard>

                {/* EMPRESA SUBCONTRATADA */}
                <div className="subcontractor-box">
                    <label className="d-flex align-center gap-10" style={{ fontWeight: 'bold' }}>
                        <input type="checkbox" checked={formData.interviene_subcontrata} onChange={(e) => setFormData({...formData, interviene_subcontrata: e.target.checked})} /> 
                        ¿INTERVIENE EMPRESA SUBCONTRATADA?
                    </label>
                    {formData.interviene_subcontrata && (
                        <select value={formData.id_usuario_subcontrata || ''} required className="main-select w-100 mt-10" onChange={(e) => setFormData({...formData, id_usuario_subcontrata: e.target.value})}>
                            <option value="">-- Responsable --</option>
                            {usuarios.map(u => <option key={u.id_usuario} value={u.id_usuario}>{u.nombre} {u.apellidos}</option>)}
                        </select>
                    )}
                </div>

                {/* TRABAJADORES SUBCONTRATA */}
                {formData. interviene_subcontrata &&(
                    <ExpandableCard title="Trabajadores de Subcontrata" icon="👷">
                        <div className="worker-grid">
                            {trabajadores.map((t, idx) => (
                                <div key={idx} className="worker-card">
                                    <div className="worker-header">
                                        <strong>TRABAJADOR #{idx + 1}</strong>
                                        <button type="button" onClick={() => setTrabajadores(trabajadores.filter((_, i) => i !== idx))} className="del-btn">Eliminar</button>
                                    </div>
                                    <div className="row">
                                        <input className="main-input flex-1" placeholder="Nombre" value={t.nombre || ''} onChange={e => updateTrabajador(idx, 'nombre', e.target.value)} />
                                        <input className="main-input flex-1" placeholder="Apellidos" value={t.apellidos || ''} onChange={e => updateTrabajador(idx, 'apellidos', e.target.value)} />
                                    </div>
                                    <div className="row">
                                        <input className="main-input w-100" placeholder="Empresa Subcontrata..." value={t.empresa || ''} onChange={e => updateTrabajador(idx, 'empresa', e.target.value)} />
                                    </div>
                                    <div className="hab-grid-full">
                                        {[
                                            {id: 'carretilla_elevadora', label: 'Carretilla Elev.'},
                                            {id: 'carretilla_telescopica', label: 'C. Telescópica'},
                                            {id: 'plataforma_elevadora', label: 'Pla. Elevadora'},
                                            {id: 'puente_grua', label: 'Puente Grúa'},
                                            {id: 'espacios_confinados', label: 'Esp. Confinados'},
                                            {id: 'formacion_altura', label: 'F. Altura'},
                                            {id: 'baja_tension', label: 'Baja Tensión'},
                                            {id: 'alta_tension', label: 'Alta Tensión'},
                                            {id: 'camion_pluma', label: 'Camión Pluma'},
                                            {id: 'grua', label: 'Grúa'},
                                            {id: 'recurso_preventivo', label: 'RECURSO PREVENTIVO', special: true}
                                        ].map(hab => (
                                            <label key={hab.id} className={`hab-item ${hab.special ? 'span-2' : ''} ${t[hab.id] ? (hab.special ? 'special-checked' : 'checked') : ''}`}>
                                                <input type="checkbox" checked={t[hab.id]} onChange={e => updateTrabajador(idx, hab.id, e.target.checked)} />
                                                {hab.label}
                                            </label>
                                        ))}
                                        <input className="main-input span-2" placeholder="Otros..." value={t.otros || ''} onChange={e => updateTrabajador(idx, 'otros', e.target.value)} />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button type="button" onClick={addTrabajador} className="add-btn">+ Añadir Trabajador</button>
                    </ExpandableCard>
                )}

            </form>
            {/* --- COMPONENTE FLOTANTE: ANEXO ESCALERA --- */}
            {showEscaleraModal && (
                <PermisoEscalera 
                    datosPrevios={datosEscaleraEditados} 
                    usuarioActual={currentUser.user}
                    // Si tiene permiso de edición, la funcion se activa, sino, oncultamos el boton
                    onSave={(nuevosDatos) => {
                        if (puedeEditarEscalera()) {
                            handleActualizarEscalera(nuevosDatos);
                        } else {
                            Swal.fire('Solo Lectura', 'No tienes permisos para modificar el anexo en esta etapa del proceso.', 'info');
                        }
                    }}
                    onCancel={() => setShowEscaleraModal(false)}
                    // Le pasamos un prop "readOnly" al componente para que desactive los inputs si no se puede editar
                    readOnly={!puedeEditarEscalera()} 
                />
                
            )}
        </div>
    );
};

export default EditHPTScreen;